import Agent from './agent.container'

export default Agent
